export default __webpack_public_path__ + "static/media/icon_account_gray.4c60b0f5.svg";